export default class Dice {
  static d100() {
    return Math.ceil(Math.random() * 100);
  }

  static d2(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 2);
    }
    return result;
  }

  static d3(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 3);
    }
    return result;
  }

  static d4(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 4);
    }
    return result;
  }

  static d6(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 6);
    }
    return result;
  }

  static d10(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 10);
    }
    return result;
  }

  static d12(count = 1) {
    let result = 0;
    for (let i = 0; i < count; i += 1) {
      result += Math.ceil(Math.random() * 12);
    }
    return result;
  }
}
